// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

function StyleInjector() {
  return (
    <style>{`
      html { scrollbar-gutter: stable; }
      .content-fade { opacity: 0; animation: fade-in .25s ease forwards; }
      @keyframes fade-in { to { opacity: 1 } }
      @keyframes loader-blink {
        0% { opacity: .4; }
        50% { opacity: 1; }
        100% { opacity: .4; }
      }
      .loader-blink {
        animation: loader-blink 1.4s ease-in-out infinite;
      }
    `}</style>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyleInjector />
    <App />
  </React.StrictMode>
);
